import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;

  a {
    font-weight: bold;
    font-size: larger;
    text-decoration: none;

    color: #071242;
  }
`;

export const Categorias = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: 5px;
  margin: 4px 0 6px 0;

  span {
    display: flex;
    height: 20px;
    width: fit-content;
    min-width: 73px;
    max-width: 232px;

    background: #90cbf0;
    padding: 0 5px;
    border-radius: 5px;

    align-items: center;
    justify-content: center;

    font-size: x-small;
    font-weight: bold;
  }
`;

export const Autores = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;

  gap: 3px;
  span {
    color: #707070;
    font-weight: 600;
  }
`;
export const Revista = styled.i`
  font-size: 11px;
`;

export const PalavrasChave = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: start;
  margin-top: 6px;

  p {
    font-weight: bold;
    font-size: 12px;
  }

  i {
    font-size: 12px;
    font-weight: normal;
  }
`;
